module.exports = __webpack_public_path__ + "img/0.baabeb86.png";